import React from 'react'
import { Modal, RatchetIcon, useResponsiveWrapperContext } from '@usap/uicomponents'
import * as Styled from './InstallationQuotesWmo.css'
import InstallationQuotesPopupContentWmo from './InstallationQuotesPopupContentWmo'

const InstallationQuotesWmo = ({
  desktopLearnMoreTrackerID,
  mobileLearnMoreTrackerID,
  onLearnMore,
  onCloseCallback,
  showModal,
}) => {
  const { isDesktop } = useResponsiveWrapperContext()

  return (
    <>
      <Styled.DifmFallbackContainer id="installation-quotes">
        <RatchetIcon />
        <Styled.MessageContainer>
          <Styled.Header>
            Need Help With Installation?
          </Styled.Header>

          <Styled.Message>
            Installation quotes from certified shops at the best price near you.
            Need Help With Installation?
            {' '}
          </Styled.Message>
          <Styled.LearnMoreButton
            onClick={onLearnMore}
            data-testid={isDesktop ? desktopLearnMoreTrackerID : mobileLearnMoreTrackerID}
          >
            Learn More
          </Styled.LearnMoreButton>
        </Styled.MessageContainer>
      </Styled.DifmFallbackContainer>

      <Modal
        open={showModal}
        onOpenChange={onCloseCallback}
        content={<InstallationQuotesPopupContentWmo />}
        header="Find the Right Part and the Right Shop"
      />
    </>
  )
}

export default React.memo(InstallationQuotesWmo)
